import Button from '@atlaskit/button/standard-button';
import { Checkbox } from '@atlaskit/checkbox';
import { ErrorMessage } from '@atlaskit/form';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import SectionMessage from '@atlaskit/section-message';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { Certification } from '@atlassian/mpac-ui';
import React, { useState } from 'react';
import { ANALYTICS_EDIT_DRAFT, ANALYTICS_SUBMIT_AND_PUBLISH, ANALYTICS_SUBMIT_AND_PUBLISH_CONFIRMATION_MODAL } from '../../analytics';
import { appTrustDataAdapter } from '../../AppTrustDataAdapter';
import { QuestionAnswerSection } from '../../CustomerComponents';
import { usePrivacySecurityAnalytics } from '../../hooks/usePrivacySecurityAnalytics';
import { privacySecurityConfig } from '../../privacySecurityConfig';
import { getQnA, updatePrivacySecurityConfig } from '../../utils';
import { ActionContainer, ConsentContainer, H2, Header, SectionHeading } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line max-lines-per-function
const PrivacyAndSecurityPreviewAndPublish = _ref => {
  let {
    appListingData,
    appTrustData,
    appName,
    onEdit,
    onPublish
  } = _ref;
  const {
    enableForgeRemoteDataResidencyChanges
  } = useStatsig();
  const [consent, setConsent] = useState(false);
  const [consentError, setConsentError] = useState(false);
  const consentHandling = () => {
    setConsent(!consent);
    setConsentError(false);
  };
  const {
    fireButtonEvent
  } = usePrivacySecurityAnalytics();

  // FUNCTIONS FOR CONFIRMATION HANDLING
  // ## START
  const [isPublishModalOpen, setIsPublishMdoalOpen] = useState(false);
  const openPublishModal = () => {
    if (!consent) {
      setConsentError(true);
      return;
    }
    setIsPublishMdoalOpen(true);
    fireButtonEvent(ANALYTICS_SUBMIT_AND_PUBLISH);
  };
  const closePublishModal = () => setIsPublishMdoalOpen(false);
  const handlePublishModalSubmit = () => {
    closePublishModal();
    onPublish();
    fireButtonEvent(ANALYTICS_SUBMIT_AND_PUBLISH_CONFIRMATION_MODAL);
  };
  // ## END

  const handleEditDraft = () => {
    fireButtonEvent(ANALYTICS_EDIT_DRAFT);
    onEdit();
  };
  const transformedAppTrustData = appTrustDataAdapter(appListingData, appTrustData);
  const {
    partner,
    cloudFortified
  } = transformedAppTrustData;
  const updatedprivacySecurityConfig = enableForgeRemoteDataResidencyChanges() ? updatePrivacySecurityConfig(privacySecurityConfig) : privacySecurityConfig;
  const previewInfoBanner = /*#__PURE__*/_jsx(SectionMessage, {
    appearance: "warning",
    children: /*#__PURE__*/_jsxs("p", {
      children: ["Below is the preview of your responses as it would appear on the app listing page. Please select ", /*#__PURE__*/_jsx("b", {
        children: "Submit and Publish"
      }), " to make the changes live, or ", /*#__PURE__*/_jsx("b", {
        children: "Edit draft"
      }), " to continue editing."]
    })
  });
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(SectionHeading, {
      children: [/*#__PURE__*/_jsx(Header, {
        children: /*#__PURE__*/_jsx(H2, {
          children: "Privacy & Security Details"
        })
      }), previewInfoBanner]
    }), updatedprivacySecurityConfig.map(_ref2 => {
      let {
        heading,
        expandText,
        qna
      } = _ref2;
      return /*#__PURE__*/_jsx(QuestionAnswerSection, {
        questionAndAnswers: getQnA(qna, transformedAppTrustData),
        heading: heading,
        expandButton: {
          text: expandText,
          maxCount: 3
        }
      }, heading);
    }), (cloudFortified === null || cloudFortified === void 0 ? void 0 : cloudFortified.isStatusApproved) && partner.name && partner.url && /*#__PURE__*/_jsx(Certification, {
      appName: appName,
      partnerName: partner.name,
      partnerUrl: partner.url
    }), /*#__PURE__*/_jsxs(ConsentContainer, {
      children: [/*#__PURE__*/_jsx(Checkbox, {
        onChange: consentHandling,
        label: "I consent to the legitimacy of the information shared and consent that all information present here is correct."
      }), consentError && /*#__PURE__*/_jsx(ErrorMessage, {
        children: "Please select the checkbox to submit and publish your response."
      })]
    }), /*#__PURE__*/_jsxs(ActionContainer, {
      children: [/*#__PURE__*/_jsx(Button, {
        appearance: "primary",
        onClick: openPublishModal,
        children: "Submit and publish"
      }), /*#__PURE__*/_jsx(Button, {
        onClick: handleEditDraft,
        children: "Edit draft"
      })]
    }), /*#__PURE__*/_jsx(ModalTransition, {
      children: isPublishModalOpen && /*#__PURE__*/_jsxs(Modal, {
        onClose: closePublishModal,
        children: [/*#__PURE__*/_jsx(ModalHeader, {
          children: /*#__PURE__*/_jsx(ModalTitle, {
            children: "Submit and publish responses"
          })
        }), /*#__PURE__*/_jsx(ModalBody, {
          children: "Are you sure you want to submit these responses? The responses once submitted will go live immediately on your app listing page, and will also trigger an internal review within our team."
        }), /*#__PURE__*/_jsxs(ModalFooter, {
          children: [/*#__PURE__*/_jsx(Button, {
            appearance: "subtle",
            onClick: closePublishModal,
            children: "Cancel"
          }), /*#__PURE__*/_jsx(Button, {
            appearance: "primary",
            onClick: handlePublishModalSubmit,
            autoFocus: true,
            children: "Submit responses"
          })]
        })]
      })
    })]
  });
};
export default PrivacyAndSecurityPreviewAndPublish;